<template>
  <div>
    <v-container
      v-if="!isLoading"
      fluid>
      <v-progress
      v-model="inProgress"></v-progress>
      <v-snackbar
        v-model="resultBar">
        {{ resultBarText }}
      </v-snackbar>
      <v-student-profile-display-card
        :student="student"
        :teachers="teachers"
        v-if="student && !isEdit"
        @edit-button-click="isEdit=!isEdit"
        @teacher-avatar-click="toTeacher"
        @delete-lesson-button-click="deleteLesson"/>
      <v-student-profile-edit-card
        v-model="updateValue"
        v-else-if="student && isEdit"
        @return-button-click="isEdit=!isEdit"
        @add-schedule-button-click="addNewSchedule()"
        @delete-schedule-button-click="deleteSchedule()"
        @update-button-click="update()"/>
      <v-error-dialog
        v-model="errorDialog"
        :message="updateError"
        />
      <v-dialog
        v-model="updateDialog"
        max-width="320"
        @click:outside="updateDialog=false"
        >
        <v-card
          class="main--text">
          <v-container>
            <v-row
              justify=center>
              <v-col
                cols=auto>登録情報を更新しました！</v-col>
            </v-row>
            <v-row
              justify=center>
              <v-col
                cols=auto>
                <v-btn
                  depressed
                  outlined
                  rounded
                  color='primary'
                  class="main--text"
                  @click="()=>{
                    isEdit=!isEdit
                    updateDialog=false
                  }"
                  >
                  OK
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
    <Loading v-else/>
    
  </div>
</template>

<script>
import VStudentProfileDisplayCard from "@/components/organisms/parent/VStudentProfileDisplayCard.vue"
import VStudentProfileEditCard from "@/components/organisms/parent/VStudentProfileEditCard.vue"
import VErrorDialog from '@/components/organisms/parent/VErrorDialog.vue'
import Loading from '@/components/organisms/Loading'
import VProgress from '@/components/organisms/VProgress'
import { StudentRepository } from "@/repository/StudentRepository"
import { TeacherRepository } from "@/repository/TeacherRepository"
import { firestore } from "@/repository/client/firestore.js"
import { LessonDeleter } from "@/service/lesson/delete-lesson"
import { UpdateStudent } from '@/service/student/update-student'

export default {
  components: {
    VStudentProfileDisplayCard,
    VStudentProfileEditCard,
    VErrorDialog,
    Loading,
    VProgress
  },
  props: {
    studentId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      parent: this.$store.getters.parent,
      isEdit: false,
      teachers: null,
      updateValue: null,
      updateError: null,
      errorDialog: false,
      updateDialog: false,
      isLoading: true,
      inProgress: false,
      resultBar: false,
      resultBarText: ""
    }
  },
  methods: {
    async update () {
      this.inProgress = true
      try {
        const updater = new UpdateStudent(firestore, this.student)
        this.parent = await updater.execute(this.updateValue)
        this.inProgress = false
        this.updateDialog = true
      } catch (e) {
        this.updateError = e.message
        this.inProgress = false
        this.errorDialog = true
      }

    },
    addNewSchedule () {
      this.updateValue.availableSchedules.addNew()
    },
    deleteSchedule (schedule) {
      if (this.updateValue.availableSchedules.length() > 1)
        this.updateValue.availableSchedules.remove(schedule)
    },
    toTeacher(teacher) {
      this.$emit('teacher-avatar-click', teacher)
    },
    async deleteLesson(lessonId) {
      this.inProgress = true
      const deleter = new LessonDeleter(firestore, this.parent)
      this.parent = await deleter.execute(lessonId)
      this.$store.commit('loginAsParent', this.parent)
      this.inProgress = false
      this.resultBarText = "授業の予定を削除しました"
      this.resultBar = true
    }
  },
  created: async function () {
    const teacherRepo = new TeacherRepository(firestore)
    this.teachers = await teacherRepo.collect(this.student.teacherIds)
    this.updateValue = { ...this.student }
    this.isLoading = false
  },
  computed: {
    student () {
      return this.parent.findStudent(this.studentId)
    }
  }
}
</script>
